import { render, staticRenderFns } from "./Quotes.vue?vue&type=template&id=0c412530&scoped=true&"
import script from "./Quotes.vue?vue&type=script&lang=js&"
export * from "./Quotes.vue?vue&type=script&lang=js&"
import style0 from "./Quotes.vue?vue&type=style&index=0&id=0c412530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c412530",
  null
  
)

export default component.exports